import { ethers } from 'ethers'

/**
 * Format token amount (handle different decimals)
 * @param amount Raw amount
 * @param decimals Number of decimals
 * @returns Formatted amount string
 */
export const formatTokenAmount = (amount: bigint | string, decimals: number = 18): string => {
  return ethers.formatUnits(amount, decimals)
}

/**
 * Parse token amount
 * @param amount Amount string
 * @param decimals Number of decimals
 * @returns Parsed bigint
 */
export const parseTokenAmount = (amount: string | number, decimals: number = 18): bigint => {
  return ethers.parseUnits(amount.toString(), decimals)
}

/**
 * Generate transaction deadline
 * @param minutes Deadline minutes, default 5 minutes
 * @returns Deadline timestamp (seconds)
 */
export const generateDeadline = (minutes: number = 5): bigint => {
  return BigInt(Math.floor(Date.now() / 1000) + minutes * 60)
}

/**
 * Calculate minimum output amount with slippage protection
 * @param amountOut Expected output amount
 * @param slippagePercent Slippage percentage, default 1%
 * @returns Minimum output amount with slippage
 */
export const calculateMinAmountOut = (
  amountOut: string | bigint,
  slippagePercent: number = 1,
): bigint => {
  const amountOutBigInt = typeof amountOut === 'string' ? parseTokenAmount(amountOut) : amountOut
  const slippageMultiplier = (100 - slippagePercent) / 100
  return (amountOutBigInt * BigInt(Math.floor(slippageMultiplier * 10000))) / 10000n
}
